import { useEffect, useRef } from 'react';

export default function InvestorEventPage() {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== 'https://form.jotform.com' && event.origin !== 'https://www.jotform.com') return;
      const iframe = iframeRef.current;
      if (!iframe) return;
      let data = event.data;
      if (typeof data === 'string') { try { data = JSON.parse(data); } catch { return; } }
      if (data?.action === 'setHeight' && data?.height) {
        iframe.style.height = data.height + 'px';
      }
    };
    window.addEventListener('message', handleMessage);

    const script = document.createElement('script');
    script.src = 'https://cdn.jotfor.ms/s/umd/latest/for-form-embed-handler.js';
    script.async = true;
    script.onload = () => {
      (window as any).jotformEmbedHandler?.(
        "iframe[id='JotFormIFrame-260854394267063']",
        'https://form.jotform.com/'
      );
    };
    document.body.appendChild(script);
    return () => {
      window.removeEventListener('message', handleMessage);
      if (document.body.contains(script)) document.body.removeChild(script);
    };
  }, []);

  return (
    <div style={{ margin: 0, padding: 0, width: '100%' }}>
      <iframe
        id="JotFormIFrame-260854394267063"
        title="Apex DeFi Labs Exclusive Investor Event Registration"
        onLoad={() => window.parent.scrollTo(0, 0)}
        allowTransparency={true}
        allow="geolocation; microphone; camera; fullscreen; payment"
        ref={iframeRef}
        src="https://form.jotform.com/260854394267063"
        frameBorder={0}
        style={{ width: '100%', minHeight: '100vh', border: 'none', display: 'block' }}
        scrolling="no"
      />
    </div>
  );
}
